module.exports = __webpack_public_path__ + "media/images/home/autres-services-49ff03da53ab2bc924e82afb2207a670.jpg";